import { Box, Button, Dialog, Typography } from "@mui/material";
import { CART_DELV_TYPE } from "constants/general";
import { ROUTES } from "constants/routes";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createBooking } from "slices/bookingReducer";
import { fetchCart } from "slices/cartReducer";
import { handleSnackBar } from "slices/global";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { clearCartCache, getCartCache } from "utils/cart.util";
import BookingSuccessModal from "./success-modal";

const SummaryLineItem = ({ label, value }: any) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography
        sx={{
          color: "#A2A2A2",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: "#323232",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
        }}
      >
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          currencyDisplay: "narrowSymbol",
        }).format(value)}
      </Typography>
    </Box>
  );
};

const FinalPayment = () => {
  const { cartReducer, bookingReducer, cardReducer }: any = useAppSelector(
    (state) => state
  );
  const dispatch = useAppDispatch();
  const cartCache = getCartCache();
  const cartDelType = cartReducer?.items?.[0]?.delivery_type ?? 0;
  const [showSuccessModel, setShowSuccessModal] = useState(false);
  const defaultSelectedCard = cardReducer.cards.find(
    (c: any) => c.is_default
  )?.id;

  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      if (cartCache) {
        searchWithParams(cartCache, true);
      }
    }, 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doPayment = () => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

    const payload = {
      from_date: moment(cartCache.from_date).format("YYYY-MM-DD"),
      to_date: moment(cartCache.to_date).format("YYYY-MM-DD"),
      ...(cartDelType === CART_DELV_TYPE.PICKUP // If type of pickup then pass delivery address else pass the pickup address
        ? {
            address_id: cartCache.pickup_address_id,
            delivery_address_id: cartCache.pickup_listing_address_id,
          }
        : {
            address_id: cartCache.delivery_address_id,
          }),
      insurance_id: cartCache.insurance_id,
      booking_type: cartReducer.booking_type,
      card_id: cardReducer.cards.find((c: any) => c.is_default)?.id ?? 0,
      time_zone: timeZone,
    };

    dispatch(
      createBooking({
        data: payload,
        onSucess: () => {
          setShowSuccessModal(true);
          clearCartCache();
        },
      })
    );
  };

  const searchWithParams = (payload: any, defaultLoad = false) => {
    const params = new URLSearchParams({
      ...(payload.from_date && payload.to_date
        ? {
            start_date: payload.from_date,
            end_date: payload.to_date,
          }
        : {}),
      ...(payload.insurance_id
        ? { insurance_id: payload.insurance_id.toString() }
        : {}),
    });
    dispatch(fetchCart({ query: params.toString(), softReload: true }));
  };

  return (
    <Box
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: "10px",
        padding: "2% 3.5%",

        mt: "25px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "64px",
          color: "#323232",
          mb: "15px",
        }}
      >
        Payment Summary
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <SummaryLineItem label="Sub total" value={cartReducer.subtotal} />
        <SummaryLineItem
          label="Haystackers fee"
          value={cartReducer.haystacker_fees}
        />
        <SummaryLineItem label="Insurance" value={cartReducer.insurancePrice} />
        <SummaryLineItem
          label="Security Deposit"
          value={cartReducer.security_deposit}
        />
        <SummaryLineItem label="Taxes" value={cartReducer.taxes} />
        <Box sx={{ height: "1px", background: "#E2E2E2", my: "15px" }} />

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            sx={{
              color: "#2A2A2A",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "30px",
            }}
          >
            Total
          </Typography>
          <Typography
            color="primary"
            sx={{ fontSize: "20px", lineHeight: "30px", fontWeight: 600 }}
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              currencyDisplay: "narrowSymbol",
            }).format(cartReducer.total)}
          </Typography>
        </Box>

        <Box
          sx={{
            my: "15px",
            display: "flex",
            gap: "15px",
            justifyContent: "flex-end",
          }}
        >
          <Button
            size="large"
            variant="contained"
            sx={{
              height: "50px",
              width: "184px",
              borderRadius: "10px",
              padding: 0,
            }}
            disabled={bookingReducer.creatingBooking || !defaultSelectedCard}
            onClick={doPayment}
          >
            Pay Now
          </Button>
        </Box>
      </Box>
      {showSuccessModel && <BookingSuccessModal />}
    </Box>
  );
};

export default FinalPayment;
